import styled from 'styled-components';

import { neutral } from 'enable-ui';

import { COLOR, COLOR_CONFIG } from 'constants/color';

// Popup style customize in app/styes/index.scss since it don't nested in this component
export const CalendarWrapper = styled.div`
  .rbc-timeslot-group {
    min-height: 50px;
  }
  .rbc-time-slot {
    color: #808080;
  }
  .legend {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 12px 0px 16px;
    margin-top: 38px;
  }
  .text-supervised .rbc-event-content p {
    color: #383ecd;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .text-diy .rbc-event-content p {
    color: #006d75;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .text-assessment .rbc-event-content p {
    color: #eb2f96;
    font-weight: 500;
    font-size: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .rbc-event-label {
    display: none;
  }
  .rbc-month-view {
    border-radius: 8px;
    margin-top: 32px;
  }
  .rbc-time-view,
  .rbc-agenda-view {
    margin-top: 32px;
  }
  .rbc-month-header {
    height: 30px;
  }
  .rbc-header {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #808080;
    font-size: 13px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
  }
  .rbc-row-content {
    padding: 6px 0px;
    pointer-events: none;
  }
  .rbc-date-cell {
    text-align: left;
    padding: 0px 12px;
    padding-bottom: 6px;
  }
  .rbc-off-range .rbc-button-link {
    color: ${neutral['neutral-6']};
  }
  .rbc-button-link {
    color: #222222;
    font-family: 'Archivo', sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0em;
  }
  .rbc-off-range-bg {
    background: #00000000;
  }
  .rbc-row-segment {
    height: 34px;
    padding: 0px 12px;
    padding-bottom: 6px;
  }
  .rbc-event {
    pointer-events: auto;
    border-radius: 6px;
    padding: 3px 10px;
    display: flex;
    justify-content: space-between;
  }
  .rbc-selected {
    border: none;
  }
  .rbc-show-more {
    pointer-events: auto;
    color: ${neutral['neutral-7']} !important;
    font-size: 13px;
    font-weight: 400;
    background-color: transparent;
  }
  .rbc-header,
  .rbc-day-bg {
    border-color: ${neutral['neutral-4']};
    cursor: pointer;
    &:hover {
      background-color: ${neutral['neutral-4']};
    }
    :not([disabled]) {
      cursor: pointer;
      &:hover {
        background-color: ${neutral['neutral-4']};
      }
    }
  }
  .rbc-month-row:last-child {
    .rbc-day-bg:first-child {
      border-bottom-left-radius: 8px;
    }
    .rbc-day-bg:last-child {
      border-bottom-right-radius: 8px;
    }
  }
  .rbc-date-cell {
    cursor: pointer;
    &[disabled] {
      cursor: not-allowed;
      pointer-events: none;

      .rbc-button-link {
        text-decoration: line-through;
        color: ${neutral['neutral-4']};
      }
    }
    text-align: right;
  }
  .rbc-today {
    background: none;
  }
  .rbc-date-cell.rbc-now.rbc-current .rbc-button-link {
    color: #ffffff;
    background-color: #fd8a24;
    padding: 0px 6px;
    border-radius: 6px;
  }

  .rbc-button-link.rbc-show-more {
    border-radius: 6px;
    padding: 3px 10px;
    width: 100%;
    text-align: left;
    &:hover {
      background-color: ${neutral['neutral-3']};
    }
  }

  .rbc-addons-dnd-resizable {
    width: 100%;
  }
  .rbc-time-content {
    border-top: 1px solid #ddd;
  }
  .custom-calendar-day {
    .rbc-time-content {
      border-top: none !important;
    }
  }
  .custom-calendar-time {
    .rbc-header {
      border-bottom-width: 0px;
      height: 44px;
      border-color: #ddd;
    }
    .rbc-button-link {
      color: #808080;
    }
    .rbc-time-view {
      border-radius: 12px;
    }
    .rbc-timeslot-group {
      border-bottom: none;
      border-top: 1px solid #ddd;
    }
    .rbc-day-slot .rbc-time-slot {
      border-top: none;
    }
    .rbc-timeslot-group:first-child {
      border-top: none;
    }
  }

  .rbc-allday-cell {
    display: none;
  }
  .rbc-header {
    font-size: 16px !important;
  }
  .rbc-button-link {
    font-size: 16px;
  }

  .dropdown-children {
    div {
      background: ${COLOR_CONFIG.white};
    }
  }

  .dropdown {
    background: ${COLOR_CONFIG.white};

    .dropdown-item {
      background: ${COLOR_CONFIG.white};

      &:hover {
        background: ${COLOR.neutral['neutral-4']};
      }
    }
  }
`;

export const CustomCalendarInput = styled.div`
  .es-calendar-content {
    background: ${COLOR_CONFIG.white};
    border: 1px solid ${COLOR.neutralTrans['neutralTrans-25']};
    border-radius: 12px;
    padding: 6px 12px;
    height: 32px;

    svg {
      display: none;
    }

    p {
      color: ${COLOR_CONFIG['neutral-text']};
    }
  }

  .dropdown-children {
    div {
      min-width: 146px;
    }
  }
`;
